const officers = [
    { name: "Ramachandran Mampully", role: "President" ,phone:"+91 94279 52027"},
    { name: "Parashar Raval", role: "Secretary" ,phone:"+91 99989 31540" },
    { name: "Urvish Thakkar", role: "Treasurer" ,phone:"+91 99986 11908"},
  ];
  
//   const directors = [
//     { name: "Pankaj Bansal"},
//     { name: "Chandresh Mehta"},
//     { name: "Hitesh Solanki" },
//     { name: "Bharat Panchal"},
//     { name: "Ketan Engineer"},
//     { name: "Jasmin Panchal"},
//     { name: "Ashwin Prajapati"},
//     { name: "Vishal Modi" },
    
//   ];
  
  const AboutTeam = () => {
    return (
      <section className="bg-[#f3fff4] py-20 px-6 text-gray-800">
        <div className="max-w-6xl mx-auto space-y-20">
  
          {/* Officers */}
          <div>
            <h2 className="text-4xl font-bold text-green-800 mb-6">Contact Persons</h2>
            <div className="grid md:grid-cols-3 gap-6">
              {officers.map((officer, i) => (
                <div
                  key={i}
                  className="rounded-xl border border-green-100 bg-white p-6 text-center shadow hover:shadow-md transition"
                >
                  <p className="text-xl font-semibold text-green-900 italic">{officer.name}</p>
                  <p className="mt-2 text-sm text-gray-600">{officer.phone}</p>
                </div>
              ))}
            </div>
          </div>
  
          {/* Directors */}
          {/* <div>
            <h2 className="text-4xl font-bold text-green-800 mb-6">Board of Trustees</h2>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6">
              {directors.map((director, i) => (
                <div
                  key={i}
                  className="bg-white rounded-lg border border-gray-100 px-5 py-4 shadow-sm hover:shadow transition text-center"
                >
                  <p className="text-green-900 font-medium italic">{director.name}</p>
                  <p className="text-sm text-gray-600">{director.country}</p>
                </div>
              ))}
            </div>
          </div> */}
  
          {/* Executive Committee */}
          {/* <div className="text-sm text-gray-700 border-t pt-6 italic">
            The Executive Committee is composed of the President, Vice President, Secretary, and up to six members elected by the Board for a term of two years.
          </div> */}
        </div>
      </section>
    );
  };
  
  export default AboutTeam;
  